import { satoshisToDollars, dollarsToSatoshis, formatDate, dateFromFormat } from "../../utils";
import { serviceInventoryVideoTypesToInventoryVideoTypes, inventoriesToServiceInventories, serviceInventoriesToInventories, inventoryVideoTypesToServiceInventoryVideoTypes, serviceInventoryMediaTypesToInventoryMediaTypes, inventoryMediaTypesToServiceInventoryMediaTypes } from "../inventories";
import { inventorySetToService, serviceToInventorySet } from "../inventorySet";
export var ServiceDealStatus;
(function (ServiceDealStatus) {
    ServiceDealStatus[ServiceDealStatus["INVALID"] = 0] = "INVALID";
    ServiceDealStatus[ServiceDealStatus["DRAFT"] = 100] = "DRAFT";
    ServiceDealStatus[ServiceDealStatus["READY"] = 200] = "READY";
    ServiceDealStatus[ServiceDealStatus["PAUSED"] = 300] = "PAUSED";
    ServiceDealStatus[ServiceDealStatus["CANCELLED"] = 400] = "CANCELLED";
    ServiceDealStatus[ServiceDealStatus["ARCHIVED"] = 500] = "ARCHIVED";
    ServiceDealStatus[ServiceDealStatus["TEST"] = 800] = "TEST";
})(ServiceDealStatus || (ServiceDealStatus = {}));
export var DealStatus;
(function (DealStatus) {
    DealStatus["INVALID"] = "Invalid";
    DealStatus["DRAFT"] = "Draft";
    DealStatus["READY"] = "Ready";
    DealStatus["PAUSED"] = "Paused";
    DealStatus["CANCELLED"] = "Cancelled";
    DealStatus["ARCHIVED"] = "Archived";
    DealStatus["TEST"] = "Test";
})(DealStatus || (DealStatus = {}));
const serviceStatusToDealStatus = (status) => {
    switch (status) {
        case ServiceDealStatus.INVALID:
            return DealStatus.INVALID;
        case ServiceDealStatus.DRAFT:
            return DealStatus.DRAFT;
        case ServiceDealStatus.READY:
            return DealStatus.READY;
        case ServiceDealStatus.PAUSED:
            return DealStatus.PAUSED;
        case ServiceDealStatus.CANCELLED:
            return DealStatus.CANCELLED;
        case ServiceDealStatus.ARCHIVED:
            return DealStatus.ARCHIVED;
        case ServiceDealStatus.TEST:
            return DealStatus.TEST;
        default:
            return undefined;
    }
};
export const dealStatusToServiceStatus = (status) => {
    switch (status) {
        case DealStatus.INVALID:
            return ServiceDealStatus.INVALID;
        case DealStatus.DRAFT:
            return ServiceDealStatus.DRAFT;
        case DealStatus.READY:
            return ServiceDealStatus.READY;
        case DealStatus.PAUSED:
            return ServiceDealStatus.PAUSED;
        case DealStatus.CANCELLED:
            return ServiceDealStatus.CANCELLED;
        case DealStatus.ARCHIVED:
            return ServiceDealStatus.ARCHIVED;
        case DealStatus.TEST:
            return ServiceDealStatus.TEST;
        default:
            return undefined;
    }
};
export var ServiceDealPriceType;
(function (ServiceDealPriceType) {
    ServiceDealPriceType["INVALID"] = "INVALID_COST_FUNC";
    ServiceDealPriceType["FLOOR"] = "FLOOR_PRICE";
    ServiceDealPriceType["FIXED"] = "FIXED_PRICE";
    ServiceDealPriceType["PG"] = "PROGRAMMATIC_GUARANTEED";
})(ServiceDealPriceType || (ServiceDealPriceType = {}));
export var DealPriceType;
(function (DealPriceType) {
    DealPriceType["FIXED"] = "Fixed";
    DealPriceType["FLOOR"] = "Floor";
})(DealPriceType || (DealPriceType = {}));
const servicePriceTypeToDealPriceType = (cost_func) => {
    switch (cost_func) {
        case ServiceDealPriceType.PG:
        case ServiceDealPriceType.FIXED:
            return DealPriceType.FIXED;
        case ServiceDealPriceType.FLOOR:
            return DealPriceType.FLOOR;
        default:
            return undefined;
    }
};
export var ServiceDealBidRuleType;
(function (ServiceDealBidRuleType) {
    ServiceDealBidRuleType["INVALID"] = "INVALID_TYPE";
    ServiceDealBidRuleType["CEILING"] = "CEILING_PRICE";
    ServiceDealBidRuleType["OVERRIDE"] = "OVERRIDE_PRICE";
})(ServiceDealBidRuleType || (ServiceDealBidRuleType = {}));
export var DealBidRuleType;
(function (DealBidRuleType) {
    DealBidRuleType["CEILING"] = "Ceiling";
    DealBidRuleType["OVERRIDE"] = "Override";
})(DealBidRuleType || (DealBidRuleType = {}));
const serviceDealBidRuleTypeToDealBidRuleType = (bid_rule) => {
    switch (bid_rule) {
        case ServiceDealBidRuleType.CEILING:
            return DealBidRuleType.CEILING;
        case ServiceDealBidRuleType.OVERRIDE:
            return DealBidRuleType.OVERRIDE;
        default:
            return undefined;
    }
};
const dealBidRuleTypeToServiceDealBidRuleType = (bidRule, priceType) => {
    if (priceType !== DealPriceType.FLOOR) {
        return undefined;
    }
    switch (bidRule) {
        case DealBidRuleType.CEILING:
            return ServiceDealBidRuleType.CEILING;
        case DealBidRuleType.OVERRIDE:
            return ServiceDealBidRuleType.OVERRIDE;
        default:
            return undefined;
    }
};
export var ServiceDealType;
(function (ServiceDealType) {
    ServiceDealType["INVALID"] = "INVALID_DEAL_TYPE";
    ServiceDealType["PMP"] = "PMP";
    ServiceDealType["PG"] = "PG";
    ServiceDealType["SUPER_TAG"] = "SUPERTAG";
    ServiceDealType["OPEN_MARKET"] = "OPENMARKET";
    ServiceDealType["DEAL_GROUP"] = "DEAL_GROUP";
})(ServiceDealType || (ServiceDealType = {}));
export var DealType;
(function (DealType) {
    DealType["PMP"] = "PMP";
    DealType["PG"] = "PG";
    DealType["SUPER_TAG"] = "SuperTag";
    DealType["OPEN_MARKET"] = "OpenMarket";
    DealType["DEAL_GROUP"] = "Deal Group";
})(DealType || (DealType = {}));
const serviceDealTypeToDealType = (dealType) => {
    switch (dealType) {
        case ServiceDealType.PG:
            return DealType.PG;
        case ServiceDealType.PMP:
            return DealType.PMP;
        case ServiceDealType.SUPER_TAG:
            return DealType.SUPER_TAG;
        case ServiceDealType.DEAL_GROUP:
            return DealType.DEAL_GROUP;
        default:
            return DealType.OPEN_MARKET;
    }
};
const dealPriceCostFuncToServiceCostFunc = (dealType, priceType) => {
    if (dealType === DealType.PG) {
        return ServiceDealPriceType.PG;
    }
    switch (priceType) {
        case DealPriceType.FLOOR:
            return ServiceDealPriceType.FLOOR;
        case DealPriceType.FIXED:
            return ServiceDealPriceType.FIXED;
        default:
            return undefined;
    }
};
export var ServiceDealSource;
(function (ServiceDealSource) {
    ServiceDealSource["UNASSIGNED"] = "UNASSIGNED";
    ServiceDealSource["SELF_SOURCED"] = "SELF_SOURCED";
    ServiceDealSource["PARTNER_O_AND_O"] = "PARTNER_O_AND_O";
    ServiceDealSource["PRIVATE_O_AND_O"] = "PRIVATE_O_AND_O";
    ServiceDealSource["MADHIVE_PUBLIC"] = "MADHIVE_PUBLIC";
    ServiceDealSource["MADHIVE_PRIVATE"] = "MADHIVE_PRIVATE";
})(ServiceDealSource || (ServiceDealSource = {}));
export var DealSource;
(function (DealSource) {
    DealSource["SELF_SOURCED"] = "Self-Sourced Deals";
    DealSource["PARTNER_O_AND_O"] = "Partner O&O";
    DealSource["PRIVATE_O_AND_O"] = "Private O&O";
    DealSource["MADHIVE_PUBLIC"] = "Madhive-Sourced Deals";
    DealSource["MADHIVE_PRIVATE"] = "MadSupply";
})(DealSource || (DealSource = {}));
const serviceSourceToDealSource = (status) => {
    switch (status) {
        case ServiceDealSource.SELF_SOURCED:
            return DealSource.SELF_SOURCED;
        case ServiceDealSource.PARTNER_O_AND_O:
            return DealSource.PARTNER_O_AND_O;
        case ServiceDealSource.PRIVATE_O_AND_O:
            return DealSource.PRIVATE_O_AND_O;
        case ServiceDealSource.MADHIVE_PUBLIC:
            return DealSource.MADHIVE_PUBLIC;
        case ServiceDealSource.MADHIVE_PRIVATE:
            return DealSource.MADHIVE_PRIVATE;
        default:
            return undefined;
    }
};
export const dealSourceToServiceSource = (status) => {
    switch (status) {
        case DealSource.SELF_SOURCED:
            return ServiceDealSource.SELF_SOURCED;
        case DealSource.PARTNER_O_AND_O:
            return ServiceDealSource.PARTNER_O_AND_O;
        case DealSource.PRIVATE_O_AND_O:
            return ServiceDealSource.PRIVATE_O_AND_O;
        case DealSource.MADHIVE_PUBLIC:
            return ServiceDealSource.MADHIVE_PUBLIC;
        case DealSource.MADHIVE_PRIVATE:
            return ServiceDealSource.MADHIVE_PRIVATE;
        default:
            return ServiceDealSource.UNASSIGNED;
    }
};
export const dealTypeToServiceType = (dealType) => {
    switch (dealType) {
        case DealType.PG:
            return ServiceDealType.PG;
        case DealType.PMP:
            return ServiceDealType.PMP;
        case DealType.SUPER_TAG:
            return ServiceDealType.SUPER_TAG;
        case DealType.OPEN_MARKET:
            return ServiceDealType.OPEN_MARKET;
        case DealType.DEAL_GROUP:
            return ServiceDealType.DEAL_GROUP;
        default:
            return undefined;
    }
};
export var DealCategory;
(function (DealCategory) {
    /**
     * Default (no specified inventory_set)
     * — requires `product` & `publisherGroupId` on line item,
     * - was the only targeting type allowed, prior to 6/2023
     */
    DealCategory["PRODUCT_ONLY"] = "product-only";
    /**
     * PG Deal (Programmatic Guaranteed) Deals
     * - only `inventory_set` used
     * — no other targeting related data applied on line item
     */
    DealCategory["PG_DEAL"] = "pg-deal";
    /**
     * Non-PG deal, requires Non-PG Deal in `inventory_set`
     * — (optionally) line item can also have `product` & `publisherGroupId`
     */
    DealCategory["NON_PG_DEAL"] = "non-pg-deal";
})(DealCategory || (DealCategory = {}));
export const DealCategoryLabel = {
    [DealCategory.PRODUCT_ONLY]: "Product Only",
    [DealCategory.PG_DEAL]: "PG Deal",
    [DealCategory.NON_PG_DEAL]: "PMP Deals and SuperTags"
};
export const serviceToDeal = (base) => {
    const { id, name, status: service_status, deal_id, content_owner: contentOwner, negotiated_volume: negotiatedVolume, geo_targeting: geoTargeting, audience_targeting: audienceTargeting, created_by: createdBy, updated_by: updatedBy, is_group: isGroup, start_date, end_date, created_at: { seconds: created } = { seconds: 0 }, updated_at: { seconds: updated } = { seconds: 0 }, media_types, video_types, notes, fallback_app: fallbackApp, always_use_fallback: alwaysUseFallback, source: serviceSource, add_to_madhive_supply_group: addToMadhiveSupplyGroup, annotations } = base;
    // price can be null and you can't destructure from null.
    const basePrice = base.price || {};
    const { cpm, cost_func, bid_rule = {} } = basePrice;
    const inventories = serviceInventoriesToInventories(base.inventories || []);
    const mediaTypes = serviceInventoryMediaTypesToInventoryMediaTypes(media_types) || [];
    const videoTypes = serviceInventoryVideoTypesToInventoryVideoTypes(video_types) || [];
    const startDate = start_date ? dateFromFormat(start_date) : undefined;
    const endDate = end_date ? dateFromFormat(end_date) : undefined;
    const parentOrg = {
        id: base.parent_org_id,
        name: base.parent_org_name
    };
    const billingOrg = {
        id: base.billing_org_id,
        name: base.billing_org_name
    };
    const ssp = {
        code: base.ssp_code,
        name: base.ssp_name
    };
    const status = serviceStatusToDealStatus(service_status);
    const deal = {
        id: deal_id,
        type: serviceDealTypeToDealType(base.type)
    };
    const priceType = [DealType.PG, DealType.SUPER_TAG].includes(deal.type)
        ? DealPriceType.FIXED
        : servicePriceTypeToDealPriceType(cost_func);
    const price = {
        cpm: typeof cpm === "number" ? satoshisToDollars(cpm) : deal.type === DealType.PMP ? undefined : 0,
        type: priceType,
        bidRule: {
            type: serviceDealBidRuleTypeToDealBidRuleType(bid_rule.type),
            cpm: typeof bid_rule.cpm === "number" && priceType === DealPriceType.FLOOR
                ? satoshisToDollars(bid_rule.cpm)
                : undefined
        }
    };
    const { includeIds, excludeIds } = serviceToInventorySet(base.inventory_set);
    const source = serviceSourceToDealSource(serviceSource);
    return {
        id,
        name,
        ...((!!price.cpm || !!price.type) && { price }),
        ...((!!deal?.id || !!deal?.type) && { deal }),
        ...("status" in base && { status }),
        ...(("parent_org_id" in base || "parent_org_name" in base) && { parentOrg }),
        ...(("billing_org_id" in base || "billing_org_name" in base) && { billingOrg }),
        ...(("ssp_code" in base || "ssp_name" in base) && { ssp }),
        ...("content_owner" in base && { contentOwner }),
        ...("negotiated_volume" in base && { negotiatedVolume }),
        ...("geo_targeting" in base && { geoTargeting }),
        ...("audience_targeting" in base && { audienceTargeting }),
        ...("is_group" in base && { isGroup }),
        ...("media_types" in base && { mediaTypes }),
        ...("video_types" in base && { videoTypes }),
        ...("created_by" in base && { createdBy }),
        ...("updated_by" in base && { updatedBy }),
        ...(!!(includeIds || excludeIds) && { inventorySet: { includeIds, excludeIds } }),
        ...("start_date" in base && { startDate }),
        ...("end_date" in base && { endDate }),
        ...("created_at" in base && { createdAt: new Date(created * 1000) }),
        ...("updated_at" in base && { updatedAt: new Date(updated * 1000) }),
        ...("notes" in base && { notes }),
        ...("fallback_app" in base && { fallbackApp }),
        ...("always_use_fallback" in base && { alwaysUseFallback }),
        ...("source" in base && { source }),
        ...("inventories" in base && { inventories }),
        ...("add_to_madhive_supply_group" in base && { addToMadhiveSupplyGroup }),
        ...("annotations" in base &&
            annotations && {
            annotations: Object.fromEntries(Object.entries(annotations).map(([key, value]) => [
                key,
                {
                    ...(value.text && { text: value.text }),
                    ...(value.string_list && { stringList: value.string_list })
                }
            ]))
        })
    };
};
export const dealToService = (base) => {
    const { id, name, price, contentOwner: content_owner, negotiatedVolume: negotiated_volume, geoTargeting: geo_targeting, audienceTargeting: audience_targeting, status: dealStatus, deal: { type: deal_type } = {}, startDate, endDate, mediaTypes, videoTypes, notes, source: dealSource, addToMadhiveSupplyGroup: add_to_madhive_supply_group, annotations } = base;
    const inventories = inventoriesToServiceInventories(base.inventories || []);
    const parent_org_id = base.parentOrg?.id?.trim() || "";
    const billing_org_id = base.billingOrg?.id?.trim() || "";
    const deal_id = base.deal?.id?.trim() || "";
    const ssp_code = base.ssp?.code?.trim() || "";
    const start_date = startDate instanceof Date ? formatDate(startDate) : "";
    const end_date = endDate instanceof Date ? formatDate(endDate) : "";
    let { fallbackApp: fallback_app, alwaysUseFallback: always_use_fallback } = base;
    if (deal_type !== DealType.SUPER_TAG) {
        fallback_app = undefined;
        always_use_fallback = undefined;
    }
    const media_types = inventoryMediaTypesToServiceInventoryMediaTypes(mediaTypes);
    const video_types = inventoryVideoTypesToServiceInventoryVideoTypes(videoTypes, mediaTypes);
    const status = dealStatusToServiceStatus(dealStatus);
    let cpm = typeof price?.cpm === "number" ? dollarsToSatoshis(price.cpm) : undefined;
    if (cpm === undefined && deal_type !== DealType.PMP) {
        cpm = 0;
    }
    const servicePrice = {
        cpm,
        cost_func: dealPriceCostFuncToServiceCostFunc(deal_type, price?.type)
    };
    const bid_rule = {
        type: dealBidRuleTypeToServiceDealBidRuleType(price?.bidRule?.type, price?.type),
        cpm: typeof price?.bidRule?.cpm === "number" && price?.type === DealPriceType.FLOOR
            ? dollarsToSatoshis(price.bidRule.cpm)
            : undefined
    };
    if (servicePrice.cost_func === ServiceDealPriceType.FLOOR && bid_rule.type) {
        servicePrice.bid_rule = bid_rule;
    }
    const { include_ids, exclude_ids } = inventorySetToService(base.inventorySet);
    const source = dealSourceToServiceSource(dealSource);
    const type = dealTypeToServiceType(deal_type);
    let data = {
        id,
        name,
        ...("status" in base && status && { status }),
        ...("parentOrg" in base && { parent_org_id }),
        ...(!!(include_ids || exclude_ids) && { inventory_set: { include_ids, exclude_ids } }),
        ...(!!deal_type && { type }),
        ...("source" in base && { source }),
        ...("annotations" in base &&
            annotations && {
            annotations: Object.fromEntries(Object.entries(annotations).map(([key, value]) => [
                key,
                {
                    ...(value.text && { text: value.text }),
                    ...(value.stringList && { string_list: value.stringList })
                }
            ]))
        })
    };
    if (deal_type !== DealType.DEAL_GROUP) {
        data = {
            ...data,
            ...((servicePrice.cpm !== undefined || !!servicePrice.cost_func) && {
                price: servicePrice
            }),
            ...("contentOwner" in base && { content_owner }),
            ...("negotiatedVolume" in base && { negotiated_volume }),
            ...("geoTargeting" in base && { geo_targeting }),
            ...("audienceTargeting" in base && { audience_targeting }),
            ...("mediaTypes" in base && { media_types }),
            ...("videoTypes" in base && { video_types }),
            ...("billingOrg" in base && { billing_org_id }),
            ...("deal" in base && { deal_id }),
            ...("ssp" in base && { ssp_code }),
            ...("startDate" in base && { start_date }),
            ...("endDate" in base && { end_date }),
            ...("notes" in base && { notes }),
            ...("fallbackApp" in base && { fallback_app }),
            ...("alwaysUseFallback" in base && { always_use_fallback }),
            ...("inventories" in base && { inventories }),
            ...("addToMadhiveSupplyGroup" in base && { add_to_madhive_supply_group })
        };
    }
    return data;
};
//# sourceMappingURL=index.js.map